import { CardNumberElement } from "@stripe/react-stripe-js";
import axios from "axios";
import currencies from "../../Currency/currency.json";
import {
  fetchUpdatedBankingInfo,
  fetchOrderHistory,
} from "../slices/userSlice";
import { logout, initializeUserFromStorage } from "../slices/userSlice";

const apiUrl = process.env.REACT_APP_API_URL;

export const updateProfile = (userId, formData) => async (dispatch) => {
  try {
    const response = await axios.patch(`${apiUrl}/user`, {
      id: userId,
      ...formData,
    });

    if (response.status === 200) {
      localStorage.setItem(
        process.env.REACT_APP_USERKEY,
        JSON.stringify(response.data)
      );
      dispatch(fetchUpdatedBankingInfo(formData.email));
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw new Error("Failed to update profile.");
  }
};

export const deleteCardOrAccount = (email, id, type) => async (dispatch) => {
  try {
    let response;
    if (type === "Card") {
      response = await axios.get(
        `${apiUrl}/payment/deleteCard?email=${email}&cardId=${id}`
      );
    } else if (type === "Account") {
      response = await axios.get(
        `${apiUrl}/payment/deleteBankAccount?email=${email}&bankAccountId=${id}`
      );
    }

    if (response && response.status === 200) {
      await dispatch(fetchUpdatedBankingInfo(email));
    } else {
      throw new Error(`Failed to delete ${type.toLowerCase()}`);
    }
  } catch (error) {
    throw new Error(
      error.response?.data?.message || `Failed to delete ${type.toLowerCase()}`
    );
  }
};

export const createCardCustom = (formData) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${apiUrl}/payment/createCustomer?email=${formData.email}&token=${formData.token}`
    );
    if (response.status === 200) {
      await dispatch(fetchUpdatedBankingInfo(formData.email));
    } else {
      throw new Error("Failed to create customer");
    }
  } catch (error) {
    throw new Error("Failed to create customer");
  }
};

export const addPaymentCardInfo =
  (elements, formData, email, customer_enable, stripe) => async (dispatch) => {
    try {
      const cardElement = elements.getElement(CardNumberElement);
      const { token, error } = await stripe.createToken(cardElement, {
        name: formData.cardholderName,
        address_line1: formData.address1,
        address_line2: formData.address2,
        address_city: formData.city,
        address_state: formData.province,
        address_zip: formData.postal_code,
        address_country: formData.country,
      });

      if (error) throw new Error("Failed to Payment card token");

      let response;
      if (!customer_enable) {
        await dispatch(
          createCardCustom({ ...formData, token: token.id }, email)
        );
      } else {
        response = await axios.get(
          `${apiUrl}/payment/addCard?email=${email}&token=${token.id}`
        );
        if (response.data === 'credit')
          throw new Error("Failed to add card, please use Debit Card Only");
      }

      await dispatch(fetchUpdatedBankingInfo(email));
    } catch (err) {
      throw new Error("Failed to add card, please double check information");
    }
  };

export const createCustomAccount =
  (formData, loginUser) => async (dispatch) => {
    try {
      const country = loginUser.address.split(",").at(-1);
      const response = await axios.get(
        `${apiUrl}/payment/customAccount?email=${formData.email}&firstName=${
          loginUser.first_name
        }&address=${loginUser.address}&country=${loginUser.address
          .split(",")
          .at(-1)}`
      );
      if (response.status === 200) return response.data;
      else throw new Error("Failed to create bank account");
    } catch (error) {
      throw new Error("Failed to create bank account");
    }
  };

export const addDirectDepositInfo =
  (formData, account_enable, stripe, loginUser) => async (dispatch) => {
    try {
      const { token, error } = await stripe.createToken("bank_account", {
        currency: formData.currency,
        country: formData.country,
        routing_number: formData.branchNumber + formData.transitNumber,
        account_number: formData.accountNumber,
        account_holder_name: formData.accountName,
        account_holder_type: "individual",
      });

      if (error) throw new Error("Failed to create bank account token");

      if (!account_enable) {
        await dispatch(
          createCustomAccount({ ...formData, token: token.id }, loginUser)
        );
      }

      const response = await axios.get(
        `${apiUrl}/payment/bankAccount?email=${formData.email}&token=${token.id}`
      );

      if (response.status === 200) {
        await dispatch(fetchUpdatedBankingInfo(formData.email));
      } else {
        throw new Error("Failed to add bank account");
      }
    } catch (error) {
      throw new Error("Failed to add bank account");
    }
  };
